export default [
  { divider: true },
  { heading: 'SYSTEM' },
  { title: 'Feedback', icon: 'mdi-forum', click: true, function: 'feedbackToggle' },
  { title: 'FAQ', icon: 'mdi-help-circle-outline', route: { name: 'Faq' } }
];
